import { PaymentUtilService } from './../../services/payment-util/payment-util.service';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { timer, Subscription } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { UtilService, PaymentService, VariablesService, VwoService, EventsService } from '../../../../shared/services';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-upi',
  templateUrl: './upi.component.html',
  styleUrls: ['./upi.component.scss']
})
export class UpiComponent implements OnInit, OnDestroy {

  @Input() cartDetails;
  @Input() isOrderLoading;
  @Input() qrURL;
  @Input() origin;
  @Input() campaignId;
  @Input() customTag;
  @Input() option;
  @Output() dataEmit: EventEmitter<any> = new EventEmitter();
  @Output() disableOptions: EventEmitter<any> = new EventEmitter();
  @Output() cardDetailsEmit: EventEmitter<any> = new EventEmitter();

  upiForm: FormGroup;
  upiInput: FormControl;
  countdown;
  timerSub: Subscription;

  regex = {
    allUpi: /^\w.+@\w+$/,
  };

  generalSubs: Subscription[] = [];
  isMobile;

  iosSupportedIntent = ['BHIM', 'GooglePay', 'Paytm', 'PhonePe'];

  upiOffers: any = [];

  constructor(
    public utilService: UtilService,
    public paymentService: PaymentService,
    public vars: VariablesService,
    private router: Router,
    private dialog: MatDialog,
    public vwo: VwoService,
    public paymentUtilService: PaymentUtilService,
    private events: EventsService
  ) { }

  ngOnInit() {
    if (this.option?.payment_offers?.length > 0) {
      this.upiOffers = this.option?.payment_offers?.filter((item => item?.mode === 'UPI'));
    }

    this.isMobile = this.utilService?.isMobile();
    this.vars.upiTimerOuter.subscribe(res => {
      if (res) {
        this.startTimer(5 * 60);
      }
    });
    this.upiForm = new FormGroup({
      upiInput: this.upiInput = new FormControl('', [
        Validators.required, Validators.pattern(/^\w.+@\w+$/)
      ])
    });

    this.prefillUpiId();
    if (!this.isMobile) {
      this.vars.getCartInsurance.subscribe(res => {
        if (res) {
          this.cardDetailsEmit.emit(res);
        }
      });
    }
  }

  /** Prefill UPI id from last order */
  prefillUpiId() {
    this.generalSubs.push(this.vars.lastOrderInfo.subscribe({
      next: (res) => {
        if (res && res.mode_value === 'VPA' && this.regex.allUpi.test(res.upi_id || res.checksum)) {
          this.upiInput.setValue(res.upi_id || res.checksum);
        } else if (this.option?.RECOMMENDED_VPA) {
          this.upiInput.setValue(this.option?.RECOMMENDED_VPA);
        }
        this.vars.recommendedVpa = this.upiInput.value;
        this.prefillEvent({ info_1: this.upiInput.value ? 'yes' : 'no' });
      }
    }));
  }

  prefillEvent(prop: { info_1: 'yes' | 'no' }) {
    this.events.sendSystemEvent({
      eventName: 'vpa_prefill',
      info_1: prop.info_1,
      info_2: this.vars.recommendedVpa
    }).subscribe(_ => _);
  }

  /**Cancel the payment */
  cancelPayment() {
    this.vars.upiTimer = false;
    this.vars.upi_payment_status.next('canceled');
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
    this.disableOptions.next(false);
  }

  /**Countdown timer */
  startTimer(duration) {
    // const time = timer(0, 1000);
    this.timerSub = timer(0, 1000).pipe(
      take(duration),
      map(() => {
        if (duration <= 1) {
          this.cancelPayment();
        }
        return duration--;
      }),
    ).subscribe(res => {
      const seconds = Math.round(res % 60).toString();
      const minute = '0' + Math.floor(res / 60);
      this.countdown = `${minute} : ${seconds.length < 2 ? '0'.concat(seconds) : seconds}`;
    });
  }

  /**submit the payment */
  submit() {
    if (this.upiForm.valid) {
      this.isOrderLoading = true;
      const payload = {
        'vpa': this.upiInput.value
      };
      this.checkUpiIdValidation(payload);
    } else {
      this.utilService.checkValidForm(this.upiForm);
    }
  }

  checkUpiIdValidation(payload) {
    this.paymentService.vpaIdValidation(payload).subscribe((res: any) => {
      if (res.data && res.data.isVPAValid) {
        this.isOrderLoading = true;
        // this.vars.upiTimer = true;
        this.startTimer(5 * 60);
        this.disableOptions.next(true);
        const data = {
          mode: 'UPI',
          mode_value: 'VPA',
          VPA: payload.vpa,
          origin: 'payment_form'
        };
        this.dataEmit.emit(data);
        this.checkVpaResponse();
      } else {
        this.utilService.openSnackBar('Please enter valid UPI Address', 'error');
        this.isOrderLoading = false;
      }
    }, () => {
      this.isOrderLoading = false;
    });
  }

  submitOrderMobile(mode, mode_value) {
    if (this.isOrderLoading) { return; }
    const data = {
      mode: mode,
      mode_value: mode_value,
    };
    this.checkVpaResponse();
    this.dataEmit.emit(data);
  }

  checkVpaResponse() {
    this.startTimer(5 * 60);
    this.generalSubs.push(
      this.vars.upi_payment_status.subscribe(val => {
        if (val === 'success') {
          this.dialog.closeAll();
          this.router.navigate(['/new/payment-route'], {
            queryParams: this.vars.tyParams
          });
        } else if (val === 'failed') {
          this.cancelPayment();
        } else if (val === 'canceled') {
          this.isOrderLoading = false;
        }
      })
    );
  }

  /**Get the keys from the object of the options */
  getObjectKeys(obj) {
    if (obj) {
      return Object.keys(obj);
    }
  }

  ngOnDestroy() {
    this.generalSubs.forEach(s => s.unsubscribe());
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

}
